import { getBiLogger } from '../../../utils/biLogger';
import { amountToLong } from '../../../utils/amount';
import { InstantPaymentDetails } from './types';

export enum InstantPaymentModalClosedReason {
  Success = 'success',
  Decline = 'decline',
  Timeout = 'timeout',
}

export interface InstantPaymentModalBiParams {
  amountLong: number;
  orderSnapshotId: string;
  paymentMethodType: string;
  paymentProvider: string;
  transactionid: string;
  reason?: InstantPaymentModalClosedReason;
}

export const convertToBiParams = (
  paymentDetails: InstantPaymentDetails
): InstantPaymentModalBiParams => {
  return {
    amountLong: amountToLong(paymentDetails.amount),
    orderSnapshotId: paymentDetails.orderId,
    paymentMethodType: paymentDetails.paymentMethod,
    paymentProvider: paymentDetails.paymentProvider,
    transactionid: paymentDetails.chargeId,
  };
};

export const logInstantPaymentModalOpened = (
  params: InstantPaymentModalBiParams
) => {
  getBiLogger().pixModalOpened(params);
};

export const logInstantPaymentModalClosed = (
  params: InstantPaymentModalBiParams
) => {
  getBiLogger().pixModalClosed(params);
};
